import { Filters } from "@/types/filters";
import { filtersToUrl } from "./filters-to-url";

export function generateSeoUrl(filters: Filters): string {
	const baseUrl = filtersToUrl(filters);
	return baseUrl.replace(/[^a-zA-Z0-9-]/g, "").toLowerCase();
}
